module.exports = __webpack_public_path__ + "static/media/shouchiCard.7750fd8b.png";